import { useSyncExternalStore } from "react";
import { Button } from "./ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { sessionStore } from "../lib/session-store";

/** Blocking dialog once the session is really gone; the only way out is Sign in. */
export function SessionExpiredDialog() {
  const expired = useSyncExternalStore(sessionStore.subscribe, sessionStore.isExpired);
  if (!expired) return null;
  const signIn = () => {
    window.location.assign(sessionStore.amr() === "saml" ? "/admin/login" : "/login");
  };
  return (
    <Dialog open onOpenChange={() => {}}>
      <DialogContent
        hideClose
        onEscapeKeyDown={(e) => e.preventDefault()}
        onPointerDownOutside={(e) => e.preventDefault()}
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Session expired</DialogTitle>
        </DialogHeader>
        <DialogFooter>
          <Button onClick={signIn}>Sign in</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
